import {normalizeToNumber} from "@shared/utils/numbers.utils";
import {createDomElementHandler} from "@/scripts/utils/dom.utils";

export class AbProgressBarController {

  private _value: number;
  private _bgColor:  string;
  private _textColor:  string;
  private _showPerc:  boolean;

  private elOuter: HTMLElement;
  private elInnerWrapper: HTMLElement;
  private elInner: HTMLElement;
  private elText: HTMLElement;
  private elValue: HTMLElement;

  private labelText: string;

  constructor(private rootEl: HTMLElement) { }

  public syncFromAttributes() {
    const val = this.rootEl.getAttribute('value');
    this._value = normalizeToNumber(val);
    this._bgColor = this.rootEl.getAttribute('bg-color');
    this._textColor = this.rootEl.getAttribute('text-color');
    this._showPerc = this.rootEl.hasAttribute('show-perc');
  }

  private buildDom() {
    this.rootEl.classList.add("ab-progress-bar");
    this.elOuter = createDomElementHandler('div', 'ab-progress-bar__outer');
    this.elInnerWrapper = createDomElementHandler('div', 'ab-progress-bar__inner-wrapper');
    this.elInner = createDomElementHandler('div', 'ab-progress-bar__inner');
    this.elText = createDomElementHandler('div', 'ab-progress-bar__text');
    this.elValue = createDomElementHandler('div', 'ab-progress-bar__value');

    this.elText.innerHTML = this.labelText;

    this.elInner.append(this.elText, this.elValue);
    this.elInnerWrapper.appendChild(this.elInner);
    this.elOuter.appendChild(this.elInnerWrapper);
    this.rootEl.replaceChildren(this.elOuter);
  }

  public render() {
    if(!this.elOuter) {
      this.labelText = this.rootEl.textContent?.trim();
      this.buildDom();
    }
    this.elInnerWrapper.style.width = `${this._value}%`;
    if(this._bgColor?.length) {
      this.elInner.style.backgroundColor = this._bgColor;
    }
    if(this._textColor?.length) {
      this.elInner.style.color = this._textColor;
    }
    this.elValue.innerText = `${this._value}%`;
    this.elValue.style.display = this._showPerc ? 'block' : 'none';
  }

  public animate() {
    this.elInner.classList.add('animate');
  }

}